"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlipCameraButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const react_1 = require("react");
const video_frame_1 = require("../video_frame");
const camera_request_messages_1 = require("./camera_request_messages");
function FlipCameraButton({ cameraSubject, cameraRequestState, isCameraFlipRequest, onRequest, onCancel, }) {
    const [tooltipOpen, setTooltipOpen] = (0, react_1.useState)(false);
    const [tooltipMessage, setTooltipMessage] = (0, react_1.useState)();
    const [hover, setHover] = (0, react_1.useState)(false);
    const [hoverMessage, setHoverMessage] = (0, react_1.useState)();
    const pendingRequest = cameraRequestState === video_frame_1.CameraRequestState.PENDING && isCameraFlipRequest;
    const deniedRequest = cameraRequestState === video_frame_1.CameraRequestState.REQUEST_DENIED && isCameraFlipRequest;
    const abortedRequest = cameraRequestState === video_frame_1.CameraRequestState.REQUEST_TIMEOUT && isCameraFlipRequest;
    const initialRequest = cameraRequestState === video_frame_1.CameraRequestState.INITIAL;
    (0, react_1.useEffect)(() => {
        if (initialRequest) {
            setHoverMessage((0, jsx_runtime_1.jsx)(camera_request_messages_1.CameraRequestPrompt, { cameraSubject: cameraSubject }));
        }
        else if (pendingRequest) {
            setHoverMessage((0, jsx_runtime_1.jsx)(camera_request_messages_1.CameraRequestPending, {}));
        }
    }, [initialRequest, pendingRequest, cameraSubject]);
    (0, react_1.useEffect)(() => {
        if (deniedRequest || abortedRequest) {
            setTooltipMessage((0, jsx_runtime_1.jsx)(camera_request_messages_1.CameraRequestDeniedOrAborted, { requestState: cameraRequestState, onCancel: () => {
                    setTooltipOpen(false);
                    onCancel();
                }, onRequest: () => {
                    setTooltipOpen(false);
                    onRequest();
                } }));
            setTooltipOpen(true);
        }
    }, [deniedRequest, onRequest, onCancel, abortedRequest, cameraRequestState]);
    const closeTooltip = (0, react_1.useCallback)(() => {
        if (tooltipOpen) {
            setTooltipOpen(false);
            onCancel();
        }
    }, [tooltipOpen, onCancel]);
    const handleMouseEnter = (0, react_1.useCallback)(() => {
        setHover(true);
    }, []);
    const handleMouseLeave = (0, react_1.useCallback)(() => {
        setHover(false);
    }, []);
    const handleClick = (0, react_1.useCallback)(() => {
        if (initialRequest) {
            onRequest();
        }
    }, [initialRequest, onRequest]);
    return ((0, jsx_runtime_1.jsx)(ui_react_1.Sensor, Object.assign({ onClickOutside: closeTooltip, onEscape: closeTooltip }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Tooltip, Object.assign({ placement: "right", fallbackPlacements: ['left', 'top'], distance: 20, showTooltip: tooltipOpen || hover, message: tooltipOpen ? tooltipMessage : hoverMessage, borderRadius: "6px", offsetValue: cameraRequestState === video_frame_1.CameraRequestState.PENDING && isCameraFlipRequest
                ? 0
                : 15 }, { children: pendingRequest ? ((0, jsx_runtime_1.jsx)(SpinnerContainer, Object.assign({ onMouseOver: handleMouseEnter, onMouseOut: handleMouseLeave }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Spinner, { size: "40px", color: "white" }) }))) : ((0, jsx_runtime_1.jsx)(FlipCameraIconButton, { label: 'Request Opposite Camera', iconName: 'FlipIcon', background: 'black', fill: 'white', onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave })) })) })));
}
exports.FlipCameraButton = FlipCameraButton;
const FlipCameraIconButton = (0, ui_react_1.styled)(ui_react_1.IconButton) `
    opacity: 0.9;
    margin-bottom: 8px;

    &:active {
        opacity: 0.64;
        transform: scale(0.92);
    }
`;
const SpinnerContainer = ui_react_1.styled.div `
    opacity: 0.9;
    margin-bottom: 8px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
`;
//# sourceMappingURL=flip_camera_button.js.map